import React, { useEffect, useState, useRef } from "react";
import "./Packing.css";
import {
  Grid,
  Container,
  Typography,
  TextField,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Modal,
} from "@mui/material";
import { Button } from "../../components/Button/button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import {
  getPlants,
  getProducts,
  getSizes,
  getPackNo,
} from "../Dashboard/services";
import { images } from "../../config/images";
import {
  getExtruder,
  getPackingHistory,
  getShift,
  getPrinter,
  LabelPreview,
  createPacking,
  printPackingDetails,
} from "./service";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { userFootFallTracking } from "../FootFallReport/services";
const Packing = () => {
  const navigate = useNavigate();

  const [selectedPlants, setSelectedPlants] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedSize, setSelectedSize] = useState([]);
  const [selectedExtruder, setSelectedExtruder] = useState([]);
  const [selectedLine, setSelectedLine] = useState(1);
  const [selectedShift, setSelectedShift] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState([]);
  const [batchNo, setBatchNo] = useState();
  const [quantity, setQuantity] = useState();
  const [packNo, setPackNo] = useState([]);
  const [isPreview, setPreview] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // show visiblity of print popup
  const [selectedPlantId, setselectedPlantId] = useState();
  const [selectedProductId, setselectedProductId] = useState();
  const [selectedExtruderId, setselectedExtruderId] = useState();
  const [selectedPrinterId, setselectedPrinterId] = useState();
  const [selectedShiftId, setselectedShiftId] = useState();
  const [selectedSizeId, setSelectedSizeId] = useState();

  // const [formData, setFormData] = useState({
  //   selectedPlants: [],
  //   selectedProduct: [],
  //   selectedExtruder: [],
  //   selectedSize: [],
  //   selectedLine: [],
  //   selectedShift: [],
  //   selectedPrinter: [],
  //   batchNo: "",
  //   quantity: "",
  //   packNo: [],
  // });
  const getData = async () => {
    try {
      const resp = await getPlants();
      setSelectedPlants(resp.data.payload);
      setselectedPlantId(resp.data.payload[0].id); // on load set first id of plant
      const resp1 = await getProducts(resp.data.payload[0].id);
      setSelectedProducts(resp1.data.payload);
      setselectedProductId(resp1.data.payload[0].id); // on load set first id of product
      const resp2 = await getSizes(resp1.data.payload[0].id);
      setSelectedSize(resp2.data.payload);
      setSelectedSizeId(resp2.data.payload[0].id); // on load set first id of size
      const resp3 = await getExtruder(resp.data.payload[0].id);
      setSelectedExtruder(resp3.data.payload);
      setselectedExtruderId(resp3.data.payload[0].id); // on load set first id of extruder
      const resp4 = await getShift(resp.data.payload[0].id);
      setSelectedShift(resp4.data.payload);
      setselectedShiftId(resp4.data.payload[0].id);

      const resp6 = await getPrinter(
        resp.data.payload[0].id,
        resp3.data.payload[0].id
      );
      setSelectedPrinter(resp6.data.payload);
    } catch (error) {}
  };

  const retrieveData = async () => {
    if (selectedPlantId) {
      try {
        // Fetch products
        const resp1 = await getProducts(selectedPlantId);
        if (resp1.data.success && resp1.data.payload.length > 0) {
          setSelectedProducts(resp1.data.payload);
          setselectedProductId(resp1.data.payload[0].id);
        } else {
          setSelectedProducts([]);
          setselectedProductId(""); // Reset
        }
      } catch (error) {
        setSelectedProducts([]);
        setselectedProductId(""); // Reset
        console.error("Error fetching products:", error);
      }

      try {
        // Fetch extruders
        const res = await getExtruder(selectedPlantId);
        if (res.data.success && res.data.payload.length > 0) {
          setSelectedExtruder(res.data.payload);
          setselectedExtruderId(res.data.payload[0].id);
        } else {
          setSelectedExtruder([]);
          setselectedExtruderId(""); // Explicit reset
        }
      } catch (error) {
        setSelectedExtruder([]);
        setselectedExtruderId(""); // Reset
        console.error("Error fetching extruders:", error);
      }
    }
  };

  // Separate logic to fetch printers only when valid extruderId exists
  const retrievePrinters = async () => {
    if (selectedPlantId && selectedExtruderId) {
      try {
        const response = await getPrinter(selectedPlantId, selectedExtruderId);
        if (response.data.success && response.data.payload.length > 0) {
          setSelectedPrinter(response.data.payload);
          setselectedPrinterId(response.data.payload[0].id);
        } else {
          setSelectedPrinter([]);
          setselectedPrinterId("");
        }
      } catch (error) {
        setSelectedPrinter([]);
        setselectedPrinterId("");
        console.error("Error fetching printers:", error);
      }
    }
  };

  // Combined Effect
  useEffect(() => {
    retrieveData();
  }, [selectedPlantId]);

  useEffect(() => {
    retrievePrinters();
  }, [selectedPlantId, selectedExtruderId]);

  // useEffect hook to fetch data when component mounts
  useEffect(() => {
    getData();
    return () => {};
  }, []);

  useEffect(() => {
    if (selectedPlantId) {
      lastHistoryData();
    }
  }, [selectedPlantId]);

  const lastHistoryData = async () => {
    const resp5 = await getPackingHistory(selectedPlantId);
    if (resp5.data.message === "Packing History retrieved successfully.") {
      setQuantity(resp5.data.payload.quantity);
      setBatchNo(resp5.data.payload.batch_no);
    } else {
      console.log("else");
      setQuantity("");
      setBatchNo("");
    }
    const response = await getPackNo(selectedPlantId);
    if (response.data.success == true) {
      setPackNo(response.data.payload.pack_no);
    }
  };
  const [isTextFieldDisable, setTextFieldDisable] = useState(true);
  const [isQuantityTextFieldDisable, setQuantityTextFieldDisable] =
    useState(true);
  const [previewData, setPreviewData] = useState([]);
  const [isPrintingDone, setisPrintingDone] = useState(false);
  const [PrintAgainstatus, setPrintAgainstatus] = useState(false);
  const [PairId, setPairId] = useState("");
  const [printerId, setPrinterId] = useState("");

  const batchNoRef = useRef(null);
  const quantityRef = useRef(null);
  const { is_normal_user } = useSelector((state) => state.userState);

  const handlePreview = async () => {
    if (!is_normal_user) {
      setPreview(!isPreview);
      const params = {
        plant:
          selectedPlants.find((plant) => plant.id == selectedPlantId)?.name ||
          "N/A",
        batch_no: batchNo,
        product:
          selectedProducts.find((prd) => prd.id == selectedProductId)
            ?.product_name || "N/A",
        size:
          selectedSize.find((siz) => siz.id == selectedSizeId)?.size || "N/A",
        extruder:
          selectedExtruder.find((ext) => ext.id == selectedExtruderId)?.name ||
          "N/A",
        printer:
          selectedPrinter.find((prn) => prn.id == selectedPrinterId)?.name ||
          "N/A",
        shift:
          selectedShift.find((shift) => shift.id == selectedShiftId)
            ?.shift_name || "N/A",
        line: selectedLine,
        quantity: quantity,
        pack_no: packNo,
        // date: getCurrentDate()
      };
      console.log(params, "paraams", selectedSize, selectedSizeId);
      try {
        const response = await LabelPreview(params);
        console.log(response, " Label response");
        setPreviewData(response.data.payload);
      } catch (error) {
        console.log("error", error);
      }
    } else {
      toast.error("You don't have access");
    }
  };

  const handlePrintClick = () => {
    if (!is_normal_user) {
      setIsPopupOpen(true); // Show popup on print button click
    } else {
      toast.error("You don't have access");
    }
  };
  const PrintAgainHandle = async (id, printer) => {
    if (!is_normal_user) {
      setPairId(id);
      setPrinterId(printer);
      const params = {
        packing_id: id,
        printer: printer,
      };
      try {
        const Api = await printPackingDetails(params);

        if (Api.data.success == true) {
          setisPrintingDone(true);

          console.log("Apicall sucessfully", Api.data);
        }
      } catch (e) {
        // setisPrintingDone(true)
        // setisPrinting(false)

        console.log("Error from PrintAgain....");
      }
    } else {
      toast.error("You don't have access");
    }
  };
  

  useEffect(() => {
    let intervalId = null;

    const callUserFootFallTracking = () => {
      const moduleList = JSON.parse(localStorage.getItem("moduleList"));
      if (moduleList) {
        const module = moduleList.find((m) => m.name === "Packing");
        if (module) {
          const params = { module_id: module.id };
          try {
            userFootFallTracking(params);
          } catch (error) {
            console.error("Error calling userFootFallTracking:", error);
          }
        }
      }
    };

    const startTracking = () => {
      if (!intervalId) {
        console.log("▶️ Start API interval");
        callUserFootFallTracking(); // call immediately
        intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
      }
    };

    const stopTracking = () => {
      if (intervalId) {
        console.log("⏹ Stop API interval");
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTracking(); // stop when tab hidden/minimized
      } else {
        startTracking(); // resume when tab active
      }
    };

    // Setup listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Start tracking immediately if tab is visible
    if (!document.hidden) {
      startTracking();
    }

    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleConfirmPrint = async () => {
    if (!is_normal_user) {
      const params = {
        plant: selectedPlants.find((plant) => plant.id == selectedPlantId)?.id,
        batch_no: batchNo,
        product: selectedProducts.find((prd) => prd.id == selectedProductId)
          ?.id,

        size: selectedSize.find((siz) => siz.id == selectedSizeId)?.id,
        extruder: selectedExtruder.find((ext) => ext.id == selectedExtruderId)
          ?.id,
        printer: selectedPrinter.find((prn) => prn.id == selectedPrinterId)?.id,
        shift: selectedShift.find((shift) => shift.id == selectedShiftId)?.id,
        line: selectedLine,
        quantity: quantity,
        pack_no: packNo,
      };
      try {
        const resp = await createPacking(params);
        if (resp.data.success == true) {
          setIsPopupOpen(false);
          PrintAgainHandle(resp.data.payload.id, resp.data.payload.printer);

          // update pack no
          const response = await getPackNo(selectedPlantId);
          if (response.data.success == true) {
            setPackNo(response.data.payload.pack_no);
          }
        }
      } catch (error) {
        setIsPopupOpen(false);
      }
    } else {
      toast.error("You don't have access");
    }
  };

  const handleCancelPrint = () => {
    setIsPopupOpen(false); // Close popup without printing
    console.log("Printing canceled.");
  };
  const isFormValid = () => {
    return (
      selectedPlantId &&
      selectedExtruderId &&
      selectedProductId &&
      selectedShiftId &&
      selectedSizeId &&
      selectedPrinterId &&
      quantity !== "" &&
      packNo !== "" &&
      batchNo !== ""
    );
  };
  useEffect(() => {
    setPreview(false); // Reset preview to false when form data changes
  }, [
    selectedPlantId,
    selectedExtruderId,
    selectedProductId,
    selectedShiftId,
    selectedSizeId,
    selectedPrinterId,
    quantity,
    packNo,
    batchNo,
  ]);

  return (
    <>
      <div className="containerWrap">
        <Container maxWidth="xxl">
          <div className="packingHeader-wrap">
            <div className="packingTitle-wrap">
              <KeyboardBackspaceIcon
                onClick={() => navigate("/dashboard")}
                className="backArrow"
              />
              <Typography
                variant="h5"
                className="packingTitle"
                gutterBottom
                onClick={() => navigate("/dashboard")}
              >
                Packing
              </Typography>
            </div>
            <div>
              <Button
                title="history"
                classname={"border-btn"}
                onClick={() => navigate("/packing-history")}
                style={{ width: "120px", backgroundColor: "white" }}
              />
            </div>
          </div>
          <div className="packingForm-wrap">
            {/* Plant Field */}
            <div className="formField">
              <div className="formFieldLabel">Plant</div>
              <select
                className="formFieldSelect"
                value={selectedPlantId}
                onChange={(e) => setselectedPlantId(e.target.value)}
              >
                {selectedPlants && selectedPlants.length > 0 ? (
                  selectedPlants.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  ))
                ) : (
                  <option value="">No Data Found</option>
                )}
              </select>
            </div>

            {/* Batch No Field */}
            <div className="formField">
              <div className="formFieldLabel">Batch No.</div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  // defaultValue="1aHdt719adf1zs2fa"
                  value={batchNo}
                  variant="outlined"
                  onChange={(e) => setBatchNo(e.target.value)}
                  disabled={isTextFieldDisable}
                  inputRef={batchNoRef}
                  slotProps={{
                    inputLabel: {
                      style: { backgroundColor: "#F5F8FA" },
                    },
                  }}
                />
                <img
                  onClick={() => {
                    setTextFieldDisable(!isTextFieldDisable); // Enable the TextField
                    setTimeout(() => batchNoRef.current.focus(), 0); // Focus the TextField
                  }}
                  src={images.editPencil}
                  className="editIcon"
                />
              </div>
            </div>

            {/* Product Field */}
            <div className="formField">
              <div className="formFieldLabel">Product</div>
              <select
                className="formFieldSelect"
                value={selectedProductId}
                onChange={(e) => setselectedProductId(e.target.value)}
              >
                {selectedProducts ? (
                  selectedProducts.map((e) => (
                    <option value={e.product_name}>{e.product_name}</option>
                  ))
                ) : (
                  <option>{"No Data Found"}</option>
                )}
                {/* <option value="Plumbing Pipes & Fittings">
                                        Plumbing Pipes & Fittings
                                    </option> */}
              </select>
            </div>

            {/* Size Field */}
            <div className="formField">
              <div className="formFieldLabel">Size</div>
              <select
                className="formFieldSelect"
                value={selectedSizeId}
                onChange={(e) => setSelectedSizeId(e.target.value)}
              >
                {selectedSize ? (
                  selectedSize.map((event) => (
                    <option value={event.id}>{event.size}</option>
                  ))
                ) : (
                  <option>{"No Data Found"}</option>
                )}
              </select>
            </div>

            {/* Extruder Field */}
            <div className="formField">
              <div className="formFieldLabel">Extruder</div>
              <select
                className="formFieldSelect"
                value={selectedExtruderId}
                onChange={(e) => {
                  setselectedExtruderId(e.target.value);
                }}
              >
                {selectedExtruder ? (
                  selectedExtruder.map((e) => (
                    <option value={e.id}>{e.name}</option>
                  ))
                ) : (
                  <option>{"No Data Found"}</option>
                )}
                {/* <option value="Extruder 01">Extruder 01</option> */}
              </select>
            </div>

            {/* Line Field */}
            <div className="formField">
              <div className="formFieldLabel">Line</div>
              <select
                className="formFieldSelect"
                value={selectedLine}
                onChange={(e) => setSelectedLine(e.target.value)}
              >
                <option value={1}>Line 01</option>
                <option value={2}>Line 02</option>
              </select>
            </div>

            {/* Printer Field */}
            <div className="formField">
              <div className="formFieldLabel">Printer</div>

              <select
                className="formFieldSelect"
                onChange={(e) => setselectedPrinterId(e.target.value)}
              >
                {selectedPrinter ? (
                  selectedPrinter.map((e) => (
                    <option value={e.id}>{e.name}</option>
                  ))
                ) : (
                  <option>{"No Printer Found"}</option>
                )}
              </select>
            </div>

            {/* Shift Field */}
            <div className="formField">
              <div className="formFieldLabel">Shift</div>
              <select
                className="formFieldSelect"
                onChange={(e) => setselectedShiftId(e.target.value)}
              >
                {selectedShift ? (
                  selectedShift.map((e) => (
                    <option value={e.id}>{e.shift_name}</option>
                  ))
                ) : (
                  <option>{"No Data Found"}</option>
                )}
                {/* <option value="Shift 1">Shift 1</option> */}
              </select>
            </div>

            {/* Quantity Field */}
            <div className="formField">
              <div className="formFieldLabel">Quantity</div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  // defaultValue="1958"
                  value={quantity}
                  variant="outlined"
                  onChange={(e) => setQuantity(e.target.value)}
                  disabled={isQuantityTextFieldDisable}
                  inputRef={quantityRef}
                  slotProps={{
                    inputLabel: {
                      style: { backgroundColor: "#F5F8FA" },
                    },
                  }}
                />
                <img
                  onClick={() => {
                    setQuantityTextFieldDisable(!isQuantityTextFieldDisable); // Enable the TextField
                    setTimeout(() => {
                      if (quantityRef.current) {
                        quantityRef.current.focus(); // Focus the TextField
                      }
                    }, 0);
                  }}
                  src={images.editPencil}
                  className="editIcon"
                />
              </div>
            </div>

            {/* Pack. No Field */}
            <div className="formField">
              <div className="formFieldLabel">Pack No.</div>
              <TextField
                fullWidth
                // defaultValue="958"
                value={packNo}
                variant="outlined"
                autoComplete="off"
                disabled
                // onChange={(e) => setPackNo(e.target.value)}
              />
            </div>

            {/* Buttons */}
            <div className="formActions">
              <Grid item xs={6}>
                <div>
                  <Button
                    title="preview"
                    classname={isFormValid() ? "custom-button" : "border-btn"}
                    onClick={() => handlePreview()}
                    style={{
                      width: "120px",
                      backgroundColor: isFormValid() ? "#005AA6" : "#A9B0BD",
                      border: isFormValid() ? "1px solid #005AA6" : "none",
                      cursor: isFormValid() ? "pointer" : "not-allowed",
                    }}
                    disabled={!isFormValid()}
                  />
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <Button
                    title="Print"
                    classname={"border-btn"}
                    onClick={() => handlePrintClick()}
                    style={{
                      width: "120px",
                      border: "none",
                      backgroundColor: isPreview ? "#005AA6" : "#A9B0BD",
                      color: isPreview ? "#ffffff" : "#000000",
                      cursor: isPreview ? "pointer" : "not-allowed",
                    }}
                    disabled={!isPreview}
                  />
                </div>
              </Grid>
            </div>
          </div>

          {isPreview && (
            <>
              <div className="preview-container">
                <div className="preview-header">
                  <img
                    src={images.qrCode} // Replace with QR code or dynamic URL
                    alt="QR Code"
                    className="qr-code"
                  />
                  <div className="company-info">
                    <p style={{ fontWeight: "600" }}>
                      Scan for product <br />
                      Information in the Packet
                    </p>
                    <p>
                      Manufactured By <br />
                      <b>
                        <i>Astral Limited</i>
                      </b>
                    </p>
                  </div>
                </div>
                <div className="preview-table">
                  {console.log("preview", previewData)}
                  <Table>
                    <TableBody className="preview-tableBody">
                      <TableRow className="preview-tableBodyRow logo-data">
                        <TableCell colSpan={2} style={{ textAlign: "center" }}>
                          <img src={images.logo}></img>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          align="center"
                        >
                          <b>Plant</b>
                          <div>{previewData.plant_code}</div>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={2}
                          align="center"
                        >
                          <b>Batch No</b>
                          <div>{previewData.batch_no}</div>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={2}
                          align="center"
                        >
                          <b>Date</b>
                          <div>{previewData.date}</div>
                        </TableCell>
                      </TableRow>
                      <TableRow className="preview-tableBodyRow">
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={2}
                          align="center"
                        >
                          <b>Extruder No.</b>
                          <div>{previewData.extruder}</div>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          align="center"
                        >
                          <b>Line No.</b>
                          <div>{previewData.line}</div>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={2}
                          align="center"
                        >
                          <b>Packet No.</b>
                          <div>{previewData.pack_no}</div>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={2}
                          align="center"
                        >
                          <b>Shift</b>
                          <div>{previewData["shift"]}</div>
                        </TableCell>
                      </TableRow>
                      <TableRow className="preview-tableBodyRow">
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={6}
                        >
                          <b>Product Description:</b>
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          align="center"
                        >
                          <b>Qty</b>
                        </TableCell>
                      </TableRow>
                      <TableRow className="preview-tableBodyRow">
                        <TableCell
                          className="preview-tableBodyCell"
                          colSpan={6}
                        >
                          {previewData.product_description}
                        </TableCell>
                        <TableCell
                          className="preview-tableBodyCell"
                          align="center"
                        >
                          {previewData.quantity}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </div>
            </>
          )}

          {/* Confirmation Popup */}
          <Modal open={isPopupOpen} onClose={() => handleCancelPrint()}>
            <div className="popup-container" style={{ width: "343px" }}>
              <Typography variant="h6">
                Are You Sure <br />
                You Want To Print?
              </Typography>
              <div className="popup-buttons">
                <Button
                  classname={"custom-button"}
                  title="Yes"
                  onClick={handleConfirmPrint}
                  style={{ marginRight: "8px" }}
                />
                <Button
                  classname={"border-btn"}
                  color="secondary"
                  title="No"
                  onClick={() => handleCancelPrint()}
                  style={{
                    border: "none",
                    backgroundColor: "#A9B0BD",
                  }}
                />
              </div>
            </div>
          </Modal>

          {isPrintingDone ? (
            <>
              <Modal open={isPrintingDone}>
                <div className="popup-container" style={{ width: "300px" }}>
                  <Typography variant="h6">Printed</Typography>
                  <div className="popup-buttons">
                    <Button
                      classname={"custom-button"}
                      title="Yes"
                      onClick={() => {
                        setisPrintingDone(false);
                      }}
                      style={{ marginRight: "8px" }}
                    />
                    <Button
                      classname={"border-btn"}
                      color="secondary"
                      title="No"
                      onClick={() => {
                        setPrintAgainstatus(true);
                        setisPrintingDone(false);
                      }}
                      style={{
                        border: "none",
                        backgroundColor: "#A9B0BD",
                      }}
                    />
                  </div>
                </div>
              </Modal>
            </>
          ) : null}

          {PrintAgainstatus ? (
            <>
              <Modal open={PrintAgainstatus}>
                <div className="popup-container" style={{ width: "300px" }}>
                  <Typography variant="h6">Print Again?</Typography>
                  <div className="popup-buttons">
                    <Button
                      classname={"custom-button"}
                      title="Yes"
                      onClick={() => {
                        PrintAgainHandle(PairId, printerId);
                        setPrintAgainstatus(false);
                      }}
                      style={{ marginRight: "8px" }}
                    />
                    <Button
                      classname={"border-btn"}
                      color="secondary"
                      title="No"
                      onClick={() => {
                        window.location.reload();
                      }}
                      style={{
                        border: "none",
                        backgroundColor: "#A9B0BD",
                      }}
                    />
                  </div>
                </div>
              </Modal>
            </>
          ) : null}
        </Container>
      </div>
    </>
  );
};

export default Packing;
